import { Box, Chip, useMediaQuery } from "@mui/material";
import theme from "../theme";
import Flex from "./Flex";
import Text from "./Text";
import { TabData } from "./app/CustomTabs";

interface SegmentTabProps {
  value?: string;
  onChange: (tab?: string) => void;
  tabsData: TabData[];
}

export const SegmentTabs = ({
  value,
  onChange,
  tabsData: list,
}: SegmentTabProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Flex
      sx={{
        display: "flex",
        borderRadius: "10px",
        // border: '1px solid #E5E5E5',
        padding: "4px",
        // gap: '4px',
        overflowX: "auto",
        // overflowY: 'hidden',
        backgroundColor: "grey.200",
        width: isMobile ? "100%" : "fit-content",
        maxWidth: "100%",
        scrollbarWidth: "thin",
      }}
      gap={0.5}
    >
      {list.map((tab: { value: string; label: string; count?: number }) => {
        const isSelected = value === tab?.value;

        return (
          <Box
            key={tab.value}
            onClick={() => onChange(tab?.value)}
            sx={{
              position: "relative",
              flexShrink: 0,
              padding: "4px 10px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: isSelected ? "white" : "grey.200",
              border: isSelected ? "1px solid black" : "1px solid #E5E5E5",
              boxShadow: isSelected ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none",
              zIndex: isSelected ? 1 : 0,
              "&:hover": {
                backgroundColor: isSelected ? "white" : "grey.300",
              },
            }}
            aria-label={tab.label}
          >
            <Flex gap={1}>
              <Text
                sx={{
                  textAlign: "center",
                  color: isSelected ? "black" : "#666666", // Black for selected, dark grey for unselected
                  fontWeight: isSelected ? 500 : 400,
                  userSelect: "none",
                  whiteSpace: "nowrap",
                }}
              >
                {tab.label}
              </Text>

              <BadgeContent count={tab?.count ?? 0} />
            </Flex>
          </Box>
        );
      })}
    </Flex>
  );
};

const BadgeContent = ({ count }: { count: number }) => {
  if (count === 0) return null;

  return (
    <Chip
      color="error"
      variant="filled"
      size="small"
      sx={{
        fontSize: "10px",
        padding: 0,
        height: "18px",
      }}
      label={count}
    />
  );
};
